/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerimeterPointDto } from './PerimeterPointDto';
import {
    PerimeterPointDtoFromJSON,
    PerimeterPointDtoFromJSONTyped,
    PerimeterPointDtoToJSON,
    PerimeterPointDtoToJSONTyped,
} from './PerimeterPointDto';
import type { SiteLocationSummaryResponseDto } from './SiteLocationSummaryResponseDto';
import {
    SiteLocationSummaryResponseDtoFromJSON,
    SiteLocationSummaryResponseDtoFromJSONTyped,
    SiteLocationSummaryResponseDtoToJSON,
    SiteLocationSummaryResponseDtoToJSONTyped,
} from './SiteLocationSummaryResponseDto';

/**
 * 
 * @export
 * @interface SiteOperationsMapSiteResponseDto
 */
export interface SiteOperationsMapSiteResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    address: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    postalCode: string | null;
    /**
     * 
     * @type {SiteLocationSummaryResponseDto}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    city: SiteLocationSummaryResponseDto | null;
    /**
     * 
     * @type {SiteLocationSummaryResponseDto}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    province: SiteLocationSummaryResponseDto | null;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    latitude: number | null;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    longitude: number | null;
    /**
     * 
     * @type {Array<PerimeterPointDto>}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    perimeter: Array<PerimeterPointDto> | null;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    zonesCount: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    totalAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    healthyAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    warningAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    criticalAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSiteResponseDto
     */
    totalOpenIncidents: number;
}

/**
 * Check if a given object implements the SiteOperationsMapSiteResponseDto interface.
 */
export function instanceOfSiteOperationsMapSiteResponseDto(value: object): value is SiteOperationsMapSiteResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('province' in value) || value['province'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('perimeter' in value) || value['perimeter'] === undefined) return false;
    if (!('zonesCount' in value) || value['zonesCount'] === undefined) return false;
    if (!('totalAssets' in value) || value['totalAssets'] === undefined) return false;
    if (!('healthyAssets' in value) || value['healthyAssets'] === undefined) return false;
    if (!('warningAssets' in value) || value['warningAssets'] === undefined) return false;
    if (!('criticalAssets' in value) || value['criticalAssets'] === undefined) return false;
    if (!('totalOpenIncidents' in value) || value['totalOpenIncidents'] === undefined) return false;
    return true;
}

export function SiteOperationsMapSiteResponseDtoFromJSON(json: any): SiteOperationsMapSiteResponseDto {
    return SiteOperationsMapSiteResponseDtoFromJSONTyped(json, false);
}

export function SiteOperationsMapSiteResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteOperationsMapSiteResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'address': json['address'],
        'postalCode': json['postalCode'],
        'city': SiteLocationSummaryResponseDtoFromJSON(json['city']),
        'province': SiteLocationSummaryResponseDtoFromJSON(json['province']),
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'perimeter': (json['perimeter'] == null ? null : (json['perimeter'] as Array<any>).map(PerimeterPointDtoFromJSON)),
        'zonesCount': json['zonesCount'],
        'totalAssets': json['totalAssets'],
        'healthyAssets': json['healthyAssets'],
        'warningAssets': json['warningAssets'],
        'criticalAssets': json['criticalAssets'],
        'totalOpenIncidents': json['totalOpenIncidents'],
    };
}

export function SiteOperationsMapSiteResponseDtoToJSON(json: any): SiteOperationsMapSiteResponseDto {
    return SiteOperationsMapSiteResponseDtoToJSONTyped(json, false);
}

export function SiteOperationsMapSiteResponseDtoToJSONTyped(value?: SiteOperationsMapSiteResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': value['address'],
        'postalCode': value['postalCode'],
        'city': SiteLocationSummaryResponseDtoToJSON(value['city']),
        'province': SiteLocationSummaryResponseDtoToJSON(value['province']),
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'perimeter': (value['perimeter'] == null ? null : (value['perimeter'] as Array<any>).map(PerimeterPointDtoToJSON)),
        'zonesCount': value['zonesCount'],
        'totalAssets': value['totalAssets'],
        'healthyAssets': value['healthyAssets'],
        'warningAssets': value['warningAssets'],
        'criticalAssets': value['criticalAssets'],
        'totalOpenIncidents': value['totalOpenIncidents'],
    };
}

